// extracted by mini-css-extract-plugin
export var aboveInput = "_k8-0";
export var actionButton = "_k8-5";
export var actionButtonContainer = "_k8-1";
export var actionIcon = "_k8-6";
export var aiInfoContainer = "_k8-2";
export var attachmentWrapper = "_k8-7";
export var bold = "_k8-3";
export var checkIcon = "_k8-8";
export var clickingRecipientBar = "_k8-11";
export var commentThreadSwitch = "_k8-a";
export var draftImage = "_k8-b";
export var draftImageContainer = "_k8-c";
export var draftImages = "_k8-e";
export var editButton = "_k8-g";
export var editor = "_k8-f";
export var editorContainer = "_k8-y";
export var editorErrorTooltipWrapper = "_k8-9";
export var headerDivider = "_k8-h";
export var icon = "_k8-i";
export var info = "_k8-j";
export var internal = "_k8-n";
export var internalDivider = "_k8-k";
export var internalMessage = "_k8-l";
export var messageInputCard = "_k8-m";
export var messageInputForm = "_k8-o";
export var messageInputFormInternal = "_k8-p";
export var options = "_k8-q";
export var publicMessageCustomer = "_k8-s";
export var publicMessageMerchant = "_k8-r";
export var removeImageButton = "_k8-d";
export var replyButtons = "_k8-t";
export var showSignatureButton = "_k8-u";
export var spinner = "_k8-v";
export var verticalButtonDivider = "_k8-4";
export var visibilitySelector = "_k8-w";
export var warning = "_k8-x";
export var wrappingText = "_k8-z";
export var writingInternalNoteTopBorder = "_k8-10";